
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeMount,
  onMounted,
  ref,
  toRaw,
  watch,
} from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import MBloader from "@/components/MBLoader.vue";
import useLocale from "@/core/common/useLocale";

export default defineComponent({
  name: "widget-blog",
  props: {
    widgetClasses: String,
    chartColor: String,
    chartHeight: String,
  },
  components: {
    MBloader,
  },
  inject: ["ismobile"],

  setup() {
    const store = useStore();
    const blogss = ref();
    const isLoaded = ref<boolean>(false);
    const { currentLocale } = useLocale();

    onBeforeMount(async () => {
      isLoaded.value = false;
      await store.dispatch(Actions.GET_BLOGS, {
        lang: currentLocale.value || "en",
      });
      blogss.value = store.getters.getBlogFeed;
      isLoaded.value = true;
    });

    const hasData = computed(() => {
      return !!Object.keys(blogss.value).length;
    });

    /*watch(
      () => store.getters.getBlogFeed,
      function (sd) {
        blogss.value = toRaw(sd);

      });*/
    return {
      blogss,
      isLoaded,
      hasData,
    };
  },
});
